import React from "react"
import { graphql } from "gatsby"

import getThemeColor from "../utils/getThemeColor"

import Layout from "../components/Layout"
import SEO from "../components/seo"

import HeroHome from "../components/HeroHome"
import HeroMore from "../components/HeroMore"
import Communities from "../components/Communities"
import SecondaryPosts from "../components/Home/SecondaryPosts"
import PrimaryPost from "../components/Home/PrimaryPost"

import PostItemHome from "../components/PostItemHome"

import {
  Wrapper,
  Content,
  Infos,
  Title,
  Starred,
  Section,
  Highlights,
  Secondary,
  LastPosts,
  Sugestions,
  CommunityText,
  CommunityTitle,
  CommunitySub,
  ContainerButton,
  AllPosts,
} from "../components/Home/styled"

const HomePage = props => {
  const mostRecentsPosts = props.data.mostRecentsPosts.edges
  const primaryPost = props.data.primaryPost.edges
  const highlightsPosts = props.data.highlightsPosts.edges

  return (
    <>
      <Layout>
        <SEO title="Home" />
        <Wrapper>
          <HeroHome />
          <Content>
            <Infos>
              <Section>
                <Title>
                  <Starred />
                  Destaques
                </Title>
                <Highlights>
                  {primaryPost.map(
                    ({
                      node: {
                        fields: { slug },
                        frontmatter: { imagePost, author, date, title },
                      },
                    }) => (
                      <PrimaryPost
                        key={slug}
                        slug={slug}
                        date={date}
                        imagePost={imagePost}
                        author={author}
                        title={title}
                      />
                    )
                  )}
                  <Secondary>
                    {highlightsPosts.map(
                      ({
                        node: {
                          fields: { slug },
                          frontmatter: { imagePost, author, title },
                        },
                      }) => (
                        <SecondaryPosts
                          key={slug}
                          slug={slug}
                          author={author}
                          imagePost={imagePost}
                          title={title}
                        />
                      )
                    )}
                  </Secondary>
                </Highlights>
              </Section>
              <Section>
                <Title>Últimos Posts</Title>
                <LastPosts>
                  {mostRecentsPosts.map(
                    ({
                      node: {
                        fields: { slug },
                        frontmatter: {
                          background,
                          imageDescription,
                          category,
                          title,
                          author,
                        },
                      },
                    }) => (
                      <PostItemHome
                        key={slug}
                        slug={slug}
                        imageDescription={imageDescription}
                        background={background}
                        category={category}
                        title={title}
                        author={author}
                      />
                    )
                  )}
                </LastPosts>
                <ContainerButton
                  cover
                  direction="left"
                  bg={getThemeColor()}
                  duration={0.6}
                  to="/posts"
                >
                  <AllPosts>Ver todos os posts</AllPosts>
                </ContainerButton>
              </Section>
            </Infos>
          </Content>
          <HeroMore />
          <Content>
            <Sugestions>
              <CommunityText>
                <CommunityTitle>Interaja nas comunidades</CommunityTitle>
                <CommunitySub>
                  Sugestões de plataformas e comunidades para interagir com
                  outros desenvolvedores.
                </CommunitySub>
              </CommunityText>
              <Communities />
            </Sugestions>
          </Content>
        </Wrapper>
      </Layout>
    </>
  )
}

export default HomePage

export const query = graphql`
  query {
    mostRecentsPosts: allMarkdownRemark(
      sort: { fields: frontmatter___date, order: DESC }
      limit: 3
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            background
            imageDescription
            author
            category
            title
          }
        }
      }
    }
    primaryPost: allMarkdownRemark(
      sort: { fields: frontmatter___date, order: DESC }
      limit: 1
      filter: {
        frontmatter: {
          title: {
            eq: "5 novas features do JavaScript no ES2020 que você deve conhecer!"
          }
        }
      }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            background
            imagePost
            author
            date(locale: "pt-br", formatString: "DD [de] MMMM [de] YYYY")
            title
          }
        }
      }
    }
    highlightsPosts: allMarkdownRemark(
      sort: { fields: frontmatter___date, order: ASC }
      limit: 2
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            background
            imagePost
            author
            title
          }
        }
      }
    }
  }
`
